// extracted by mini-css-extract-plugin
module.exports = {"scopeCell":"style_scopeCell__1RAVf","defineScope":"style_defineScope__ZXa8q"};